<div class="container-fluid">
  <!-- Tiêu đề Quá Hạn với Biểu tượng -->
  <h1 class="h3 mb-2 text-gray-800"><i class="fas fa-exclamation-triangle"></i> Quá Hạn</h1>

  <!-- Mô tả -->
  <p class="lead">Mô-đun này cho phép bạn quản lý các mục quá hạn. Bạn có thể xem chi tiết các mục quá hạn, bao gồm tên mục danh mục, ngày đến hạn, ngày trả và số tiền phạt. Sử dụng nút 'Thêm Mục Quá Hạn' để ghi lại các mục quá hạn mới.</p>

  <!-- Nút Thêm Mục Quá Hạn -->

  <!-- Bảng Các Mục Quá Hạn -->
  <div class="card mb-4">
    <div class="card-body">
      <div class="table-responsive">

<div class="container mt-5">

  <div class="row">
      <div class="col-md-4 mb-4">
          <div class="card text-center border">
              <div class="card-body">
                  <h5 class="card-title text-dark">Tổng</h5>
                  <p class="card-text h3">
                      <span *ngIf="total">{{ total }}</span>
                      <span *ngIf="!total">Đang tải...</span>
                  </p>
              </div>
          </div>
      </div>

      <div class="col-md-4 mb-4">
          <div class="card text-center border">
              <div class="card-body">
                  <h5 class="card-title text-primary">Sắp Tới</h5>
                  <p class="card-text h3">
                      <span *ngIf="soon">{{ soon }}</span>
                      <span *ngIf="!soon">Đang tải...</span>
                  </p>
              </div>
          </div>
      </div>

      <div class="col-md-4 mb-4">
          <div class="card text-center border">
              <div class="card-body">
                  <h5 class="card-title text-secondary">Hôm Qua</h5>
                  <p class="card-text h3">
                      <span *ngIf="yesterday">{{ yesterday }}</span>
                      <span *ngIf="!yesterday">Đang tải...</span>
                  </p>
              </div>
          </div>
      </div>

      <div class="col-md-4 mb-4">
          <div class="card text-center border">
              <div class="card-body">
                  <h5 class="card-title text-success">Hôm Nay</h5>
                  <p class="card-text h3">
                      <span *ngIf="today">{{ today }}</span>
                      <span *ngIf="!today">Đang tải...</span>
                  </p>
              </div>
          </div>
      </div>

      <div class="col-md-4 mb-4">
          <div class="card text-center border">
              <div class="card-body">
                  <h5 class="card-title text-info">Ngày Mai</h5>
                  <p class="card-text h3">
                      <span *ngIf="tomorrow">{{ tomorrow }}</span>
                      <span *ngIf="!tomorrow">Đang tải...</span>
                  </p>
              </div>
          </div>
      </div>

  </div>
</div>

<div class="container mt-3">
  <!-- Tabs Bootstrap -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#all">
        <i class="fas fa-list"></i> Danh Sách
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#soon">
        <i class="fas fa-clock"></i> Sắp Tới
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#yesterday">
        <i class="fas fa-calendar-day"></i> Hôm Qua
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#today">
        <i class="fas fa-calendar-check"></i> Hôm Nay
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#tomorrow">
        <i class="fas fa-calendar-plus"></i> Ngày Mai
      </a>
    </li>
  </ul>

  <!-- Nội dung Tab -->
  <div class="tab-content">
    <div id="all" class="tab-pane fade show active">
      <ngx-datatable
        class="bootstrap"
        [rows]="circulations"
        [columnMode]="'force'"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [loadingIndicator]="loadingIndicator"
        [reorderable]="reorderable"
      >
      <ngx-datatable-column name="Member Name" prop="memberName.firstname"></ngx-datatable-column>
      <ngx-datatable-column name="Book Name" prop="catalogItemName.title"></ngx-datatable-column>
      <ngx-datatable-column name="Writer" prop="catalogItemName.writer.name"></ngx-datatable-column>
        <ngx-datatable-column name="Issue Date" prop="issueDate"></ngx-datatable-column>
        <ngx-datatable-column name="Last Date" prop="lastDate"></ngx-datatable-column>
        <ngx-datatable-column name="To Return" prop="toReturn"></ngx-datatable-column>
        <ngx-datatable-column name="Return Date" prop="returnDate"></ngx-datatable-column>
        <!-- <ngx-datatable-column name="Penalty" prop="penalty"></ngx-datatable-column> -->
        <!-- <ngx-datatable-column name="Return Status" prop="returnStatus.name"></ngx-datatable-column> -->
        <ngx-datatable-column name="Actions">
          <ng-template ngx-datatable-cell-template let-row="row">
            <button class="btn btn-outline-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Hành Động
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" (click)="openViewDialog(row)">
              <i class="fas fa-eye"></i> Xem
             </a>
              <a class="dropdown-item" (click)="openCheckOut()">
                  <i class="fas fa-shopping-cart"></i> Mượn
              </a>
              <a class="dropdown-item" (click)="openCheckIn()">
                  <i class="fas fa-undo"></i> Trả
              </a>
              <a class="dropdown-item" (click)="openRenew()">
                  <i class="fas fa-redo"></i> Gia Hạn
              </a>
              <a class="dropdown-item" (click)="openPutOnHold()">
                  <i class="fas fa-pause-circle"></i> Giữ
              </a>
          </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

    <div id="soon" class="tab-pane fade">
       <ngx-datatable
        class="bootstrap"
        [rows]="soonCirculations"
        [columnMode]="'force'"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [loadingIndicator]="loadingIndicator"
        [reorderable]="reorderable"
      >
      <ngx-datatable-column name="Member Name" prop="memberName.firstname"></ngx-datatable-column>
      <ngx-datatable-column name="Book Name" prop="catalogItemName.title"></ngx-datatable-column>
      <ngx-datatable-column name="Writer" prop="catalogItemName.writer.name"></ngx-datatable-column>
        <ngx-datatable-column name="Issue Date" prop="issueDate"></ngx-datatable-column>
        <ngx-datatable-column name="Last Date" prop="lastDate"></ngx-datatable-column>
        <ngx-datatable-column name="To Return" prop="toReturn"></ngx-datatable-column>
        <ngx-datatable-column name="Return Date" prop="returnDate"></ngx-datatable-column>
       <!--  <ngx-datatable-column name="Penalty" prop="penalty"></ngx-datatable-column>
        <ngx-datatable-column name="Return Status" prop="returnStatus.name"></ngx-datatable-column> -->
        <ngx-datatable-column name="Actions">
          <ng-template ngx-datatable-cell-template let-row="row">
            <button class="btn btn-sm btn-outline-primary" (click)="openViewDialog(row)">Xem</button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable> 
    </div>

    <div id="yesterday" class="tab-pane fade">
       <ngx-datatable
        class="bootstrap"
        [rows]="yesterdayCirculations"
        [columnMode]="'force'"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [loadingIndicator]="loadingIndicator"
        [reorderable]="reorderable"
      >
      <ngx-datatable-column name="Member Name" prop="memberName.firstname"></ngx-datatable-column>
      <ngx-datatable-column name="Book Name" prop="catalogItemName.title"></ngx-datatable-column>
      <ngx-datatable-column name="Writer" prop="catalogItemName.writer.name"></ngx-datatable-column>
        <ngx-datatable-column name="Issue Date" prop="issueDate"></ngx-datatable-column>
        <ngx-datatable-column name="Last Date" prop="lastDate"></ngx-datatable-column>
        <ngx-datatable-column name="To Return" prop="toReturn"></ngx-datatable-column>
        <ngx-datatable-column name="Return Date" prop="returnDate"></ngx-datatable-column>
       <!--  <ngx-datatable-column name="Penalty" prop="penalty"></ngx-datatable-column>
        <ngx-datatable-column name="Return Status" prop="returnStatus.name"></ngx-datatable-column> -->
        <ngx-datatable-column name="Actions">
          <ng-template ngx-datatable-cell-template let-row="row">
            <button class="btn btn-sm btn-outline-primary" (click)="openViewDialog(row)">Xem</button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable> 
    </div>

    <div id="today" class="tab-pane fade">
       <ngx-datatable
        class="bootstrap"
        [rows]="todayCirculations"
        [columnMode]="'force'"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [loadingIndicator]="loadingIndicator"
        [reorderable]="reorderable"
      >
      <ngx-datatable-column name="Member Name" prop="memberName.firstname"></ngx-datatable-column>
      <ngx-datatable-column name="Book Name" prop="catalogItemName.title"></ngx-datatable-column>
      <ngx-datatable-column name="Writer" prop="catalogItemName.writer.name"></ngx-datatable-column>
        <ngx-datatable-column name="Issue Date" prop="issueDate"></ngx-datatable-column>
        <ngx-datatable-column name="Last Date" prop="lastDate"></ngx-datatable-column>
        <ngx-datatable-column name="To Return" prop="toReturn"></ngx-datatable-column>
        <ngx-datatable-column name="Return Date" prop="returnDate"></ngx-datatable-column>
       <!--  <ngx-datatable-column name="Penalty" prop="penalty"></ngx-datatable-column>
        <ngx-datatable-column name="Return Status" prop="returnStatus.name"></ngx-datatable-column> -->
        <ngx-datatable-column name="Actions">
          <ng-template ngx-datatable-cell-template let-row="row">
            <button class="btn btn-sm btn-outline-primary" (click)="openViewDialog(row)">Xem</button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable> 
    </div>

    <div id="tomorrow" class="tab-pane fade">
       <ngx-datatable
        class="bootstrap"
        [rows]="tomorrowCirculations" 
        [columnMode]="'force'"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [loadingIndicator]="loadingIndicator"
        [reorderable]="reorderable"
      >
      <ngx-datatable-column name="Member Name" prop="memberName.firstname"></ngx-datatable-column>
      <ngx-datatable-column name="Book Name" prop="catalogItemName.title"></ngx-datatable-column>
      <ngx-datatable-column name="Writer" prop="catalogItemName.writer.name"></ngx-datatable-column>
        <ngx-datatable-column name="Issue Date" prop="issueDate"></ngx-datatable-column>
        <ngx-datatable-column name="Last Date" prop="lastDate"></ngx-datatable-column>
        <ngx-datatable-column name="To Return" prop="toReturn"></ngx-datatable-column>
        <ngx-datatable-column name="Return Date" prop="returnDate"></ngx-datatable-column>
       <!--  <ngx-datatable-column name="Penalty" prop="penalty"></ngx-datatable-column>
        <ngx-datatable-column name="Return Status" prop="returnStatus.name"></ngx-datatable-column> -->
        <ngx-datatable-column name="Actions">
          <ng-template ngx-datatable-cell-template let-row="row">
            <button class="btn btn-sm btn-outline-primary" (click)="openViewDialog(row)">Xem</button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable> 
    </div>
  </div>
</div>


